<template>
    <v-container max-width="100%">
    
      <v-container class="toolbar__container">
        <h3 style="color: #4a4a4a;">{{ $t('garageVehicle.title') }}</h3>
      </v-container>

      <v-dialog v-model="loading" width="40%" style="z-index: 10000;">
          <v-card>
              <v-card-title>
                  <span>{{ $t('garageVehicle.updatingVehicles') }}</span>
              </v-card-title>
              <v-card-text>
                  <v-progress-linear 
                      height="10"
                      color="primary"
                      indeterminate>
                  </v-progress-linear>
              </v-card-text>
          </v-card>
      </v-dialog>

      <div class="map__div" ref="mapDiv" style="margin-top: 10px;">
        <v-navigation-drawer
            v-model="showDrawer"
            absolute
            temporary
            overlay-opacity="0"
            left
            style="width: 50%; z-index: 5000"
        >
            <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('operation.searchVehicle')"
                    single-line
                    hide-details
                ></v-text-field>
            </v-toolbar>
            <v-list>
                <v-list-item 
                    v-for="(veiculo, v) in veiculosFiltered" 
                    :key="`DRAWER-${veiculo.id_veiculo}-${v}`"
                    @click="plotOnMap(veiculo)"
                >
                    <v-list-item-title>{{ veiculo.numero_ordem }}</v-list-item-title>
                    <v-list-item-subtitle>{{ veiculo.nome_cerca }}</v-list-item-subtitle>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <l-map
            ref="map"
            :zoom="zoom"
            :center="currentCenter"
            :options="mapOptions"
            @ready="onMapResize()"
        >
            <l-tile-layer :url="url" :attribution="attribution" />

            <l-control :position="'topleft'">
                <v-btn small fab @click="showDrawer = true">
                    <v-icon color="black">mdi-bus</v-icon></v-btn
                >
            </l-control>

            <l-marker
                v-if="veiculoSelected.id_veiculo"
                :lat-lng="veiculoSelected.position"
                :icon="getIcon()"
            >
                <l-tooltip :content="veiculoSelected.numero_ordem" :options="{permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip'}"></l-tooltip>
            </l-marker>
            
        </l-map>
        </div>
    </v-container>
  </template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LTooltip
} from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LTooltip
},
  data: () => ({
    search: "",
    loading: false,
    veiculos: [],
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    zoom: 18,
    currentCenter: null,
    mapOptions: {
        zoomSnap: 0.5,
    },
    veiculoSelected: {
        position: null,
        numero_ordem: null,
        id_veiculo: null,
        gps_offline: null,
    },
    timeout: null,
    showDrawer: false,
  }),
  computed: {
    center() {
      return this.$store.getters['config/centerDefault'];
    },
    veiculosFiltered() {
        if (this.search.length === 0 || !this.search) {
            return this.veiculos;
        } else {
            return this.veiculos.filter((v) => {
                return v.numero_ordem.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
                v.nome_cerca.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
            });
        }
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
    }
  },
  created() {
    this.initialize();
  },
  mounted() {},
  methods: {
    initialize() {
      this.currentCenter = this.center;
      this.populaVeiculos();
    },
    populaVeiculos() {
      this.loading = true;
      apiController.request(apiController.endpoints.getVeiculosgaragem, {
        silent: true,
        onSuccess: (response) => {
          // Aplica tradução ao nome da cerca
          this.veiculos = response.data.map(veiculo => {
            return {
              ...veiculo,
              nome_cerca: translateDbField(
                veiculo.translation_key,
                veiculo.nome_cerca
              )
            };
          });
          this.plotOnMap(this.veiculos.find((v) => v.id_veiculo === this.veiculoSelected.id_veiculo));
          this.loading = false;
          if (this.timeout) {
                clearTimeout(this.timeout);
          }
          this.timeout = setTimeout(this.populaVeiculos, 60000);
        },
        onError: (e) => {
          this.loading = false;
          EventBus.$emit('show-alert', {
            mensagem: this.$t('passenger_consult.labels.failed_to_load_vehicles'),
            tipo: 'error'
          });
          console.log(e.message);
        },
      });
    },
    onMapResize() {
        this.$refs.map.mapObject.invalidateSize();
    },
    getIcon() {
        if (this.veiculoSelected.gps_offline == "1") {
            return L.divIcon({
                className: "my-custom-pin",
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><title>bus</title><path fill="#FF0000" d="M18,11H6V6H18M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20A1,1 0 0,0 6,21H7A1,1 0 0,0 8,20V19H16V20A1,1 0 0,0 17,21H18A1,1 0 0,0 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z" /></svg>`
            });
        }
        else {
            return L.divIcon({
                className: "my-custom-pin",
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><title>bus</title><path fill="#008000" d="M18,11H6V6H18M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20A1,1 0 0,0 6,21H7A1,1 0 0,0 8,20V19H16V20A1,1 0 0,0 17,21H18A1,1 0 0,0 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z" /></svg>` 
            });
        }
    },
    plotOnMap(veiculo) {
        if (veiculo) {
            this.veiculoSelected.position = L.latLng(veiculo.lat, veiculo.lng);
            this.veiculoSelected.numero_ordem = veiculo.numero_ordem;
            this.veiculoSelected.id_veiculo = veiculo.id_veiculo;
            this.veiculoSelected.gps_offline = veiculo.gps_offline;
            this.currentCenter = [veiculo.lat, veiculo.lng];
            this.showDrawer = false;
        } else {
            this.veiculoSelected.position = null;
            this.veiculoSelected.numero_ordem = null;
            this.veiculoSelected.id_veiculo = null;
            this.gps_offline = null;
        }
    },
  },
};
</script>

<style scoped>
.map__div {
    width: 100%;
    height: 80vh;
    display: inline-block;
    position: relative;
}
</style>